import { Dispatch } from "redux";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { SERVER_DATE_TIME_FORMAT } from "@constants/date-formats";
import format from "date-fns/format";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import { setWorkflowReportMetadataSearchResults, setWorkflowReportMetadataSearchResultsLoading } from "@redux/actions/workflow-report-actions";
import { getWorkflowReportMetadataRequest } from "@requests/reports/get-workflow-report-metadata";

export const getWorkflowReportMetadataSearchResultsReduxRequest = (dispatch: Dispatch) => async (
    workflowId: string,
    startDate: Date,
    endDate: Date
) => {

    dispatch(setWorkflowReportMetadataSearchResultsLoading(true));

    const { data, error, queryParameters } = await getWorkflowReportMetadataRequest(
        workflowId,
        format(startOfDay(startDate), SERVER_DATE_TIME_FORMAT),
        format(endOfDay(endDate), SERVER_DATE_TIME_FORMAT),
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        SERVER_DATE_TIME_FORMAT
    );

    if (data) {
        const appIds = data.appIDs?.filter(x => x) || [];
        const countries = data.countries?.filter(x => x) || [];
        const rpServices = data.rpServices?.filter(x => x) || [];
        dispatch(setWorkflowReportMetadataSearchResults({
            appIDs: appIds,
            countries: countries,
            rpServices: rpServices
        }));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message,
                null,
                queryParameters
            )
        }
        dispatch(setWorkflowReportMetadataSearchResults({
            appIDs: [],
            countries: [],
            rpServices: []
        }));
        return null;
    }
};